export function multiplySize(
  size: number | string,
  factor: number,
): number | string {
  if (typeof size === "number") {
    return size * factor;
  } else if (typeof size === "string") {
    const numericValue = parseFloat(size);
    const unit = size.replace(numericValue.toString(), "");
    return `${numericValue * factor}${unit}`;
  }

  return size;
}
